import { Container, Row, Col, Card } from "react-bootstrap";
import aboutImg from "../assets/about.png";

const VALUES = [
  { icon: "🎯", title: "Clarity First", text: "We turn confusing finance jargon into simple, actionable steps anyone can follow." },
  { icon: "🤝", title: "Honest & Unbiased", text: "No sales pitches and no hidden agendas, just genuine guidance for your money." },
  { icon: "🆓", title: "Free for Everyone", text: "Every guide and calculator on our site is completely free to use, always." },
  { icon: "🇮🇳", title: "Built for India", text: "Content tailored to Indian taxes, investments and banking, not generic advice." },
];

const FOCUS = [
  "Explaining finance and investing concepts in simple language",
  "Helping users understand financial terms and processes",
  "Providing practical insights into budgeting, saving and investing",
  "Offering free, easy-to-use calculators for smart money decisions",
];

function AboutUs() {
  return (
    <Container className="py-5">
      <div className="text-center mb-5">
        <h1 className="fi-about-heading" style={{ fontSize: "2.4rem" }}>About Us</h1>
      </div>

      {/* Who We Are — text + image */}
      <Row className="align-items-center g-5">
        <Col lg={6} className="fi-article">
          <h2 className="mt-0">Who We Are?</h2>
          <p>
            our site is an independent educational platform focused on improving
            financial and money awareness across India. We are a small team of
            content researchers and writers who are passionate about simplifying
            personal finance for everyday people.
          </p>
          <p>
            We understand that budgeting, investing, taxes and banking can often
            feel overwhelming. Our goal is to make these topics easier to
            understand by presenting information in a clear, structured and
            user-friendly way.
          </p>
          <p>
            We do not represent or work with any bank or financial institution.
            All information published here is created independently and intended
            solely for educational purposes.
          </p>
        </Col>
        <Col lg={6} className="text-center">
          <img
            src={aboutImg}
            alt="Our team simplifying finance"
            className="img-fluid rounded-4 "
            style={{ maxHeight: 420, objectFit: "cover" }}
          />
        </Col>
      </Row>

      {/* Why we created this platform */}
      <Row className="mt-5">
        <Col lg={10} className="fi-article">
          <h2>Why We Created This Platform</h2>
          <p>
            Many people struggle to understand basic financial decisions, account
            types and money processes due to complicated language and unclear
            explanations. We created our site to bridge this knowledge gap.
          </p>
          <p>Our platform focuses on:</p>
          <ul>
            {FOCUS.map((f, i) => (
              <li key={i}>{f}</li>
            ))}
          </ul>
        </Col>
      </Row>

      {/* Values / What we stand for */}
      <div className="text-center mt-5 mb-4">
        <div className="fi-eyebrow">What We Stand For</div>
        <h2 className="fi-section-title">Our Core Values</h2>
      </div>
      <Row className="g-4">
        {VALUES.map((v) => (
          <Col md={6} lg={3} key={v.title}>
            <Card className="fi-card text-center">
              <Card.Body>
                <div className="fi-card-icon mx-auto">{v.icon}</div>
                <Card.Title className="fw-bold">{v.title}</Card.Title>
                <Card.Text className="text-muted">{v.text}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {/* Stats */}
      {/* <Row className="g-4 mt-1">
        <Col xs={6} md={3}>
          <div className="fi-stat fi-about-stat p-4">
            <div className="n">{ARTICLES.length}+</div>
            <small className="text-muted">In-depth guides</small>
          </div>
        </Col>
        <Col xs={6} md={3}>
          <div className="fi-stat fi-about-stat p-4">
            <div className="n">{CALCULATORS.length}</div>
            <small className="text-muted">Free calculators</small>
          </div>
        </Col>
        <Col xs={6} md={3}>
          <div className="fi-stat fi-about-stat p-4">
            <div className="n">{CATEGORIES.length}</div>
            <small className="text-muted">Finance topics</small>
          </div>
        </Col>
        <Col xs={6} md={3}>
          <div className="fi-stat fi-about-stat p-4">
            <div className="n">100%</div>
            <small className="text-muted">Free &amp; unbiased</small>
          </div>
        </Col>
      </Row> */}

      {/* CTA */}
      {/* <div className="fi-calc-result text-center p-5 mt-5">
        <h2 className="fw-bold">Have a question or suggestion?</h2>
        <p className="lead mb-4 opacity-75">
          We'd love to hear from you. Reach out anytime.
        </p>
        <Button as={Link} to="/contact" size="lg" className="btn-fi rounded-pill px-4">
          Contact Us
        </Button>
      </div> */}

      {/* <p className="text-center text-muted small mt-4 mb-0">
        Disclaimer: FinFolio provides educational content only and is not a
        SEBI-registered investment adviser. Always do your own research before
        making financial decisions.
      </p> */}
    </Container>
  );
}

export default AboutUs;
